import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Scroll window to top when the route pathname changes. */
export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
};
